import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const Table = styled.table`
  position: relative;
  border-collapse: collapse;
  width: 100%;
`;

export const Th = styled.th`
  position: sticky;
  top: 0;
  background-color: #2f6e80;

  font-size: 14px;
  color: #fff;
  z-index: 5;
  text-align: left;
  vertical-align: middle;

  padding: 10px 5px;

  &:first-of-type {
    width: 50px;
  }
`;

export const Td = styled.td`
  vertical-align: middle;
  padding: 16px 8px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;

  .custom-checkbox {
    width: 30px;
    height: 30px;
  }

  .custom-checkbox__control {
    left: 10px;
  }

  &:first-of-type {
    width: 50px;
  }

  &:last-of-type {
    width: 60px;
    text-align: right;
  }
`;

export const Tr = styled.tr`
  &:hover {
    ${Td} {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }
`;

export const StyledLink = styled(Link)`
  color: gray;

  &:hover {
    text-decoration: underline;
  }
`;
